// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {DescriptivetrainingformModuleLayout} from 'app_components/modules/admin/landings/descriptivetrainingform'
// @end

// @import events
// @end

// @import utils
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import { I18nUtil } from 'app_utils/i18n'
// @end

// @import services
import PermissionService from 'app_services/secure/permission/permissionService'
import LandingService from 'app_services/admin/landings/landingService'
import { IDescriptiveTraining } from 'app_types/admin/landings/landingTypes'
// @end

// @import types
// @end

// @ADD Component types
interface IDescriptivetrainingformModuleProps {
  title?: string
  data?: IDescriptiveTraining
  source: string
  onHandleDescriptiveTrainingSaved: (data: any) => void | null
}
interface IDescriptivetrainingformModuleState {
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class DescriptivetrainingformModule extends Component<IDescriptivetrainingformModuleProps, IDescriptivetrainingformModuleState> {

  public moduleName: string = 'module:landings'
  private permission: PermissionService
  private landingService: LandingService
  private screenNotifications: ScreenNotificationsUtil
  private i18nUtil: I18nUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IDescriptivetrainingformModuleProps) {
    super(props)
    this.state = {
    }

    this.permission = new PermissionService(this.moduleName)
    this.landingService = new LandingService()
    this.screenNotifications = new ScreenNotificationsUtil()
    this.i18nUtil = new I18nUtil()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  onHandleDescriptiveTrainingSubmit = async (formData: any) => {
    this.setState({loadingForm: 'loading'})

    const landingResponse = await this.landingService.saveDescriptiveTraining(
      {...formData, slug: this.props.source},
    )

    this.setState({loadingForm: null})

    if (landingResponse) {
      let screen_notification_label = 'components.screen_notifications.update'

      this.screenNotifications.fireToast(
        {
          message: `${this.i18nUtil.getTranslate(screen_notification_label)}`,
        },
        {
          position: 'top',
        }
      )

      if(this.props.onHandleDescriptiveTrainingSaved !== null){
        this.props.onHandleDescriptiveTrainingSaved({status: 'success'})
      }
    }
  }

  render() {
    return(
      <DescriptivetrainingformModuleLayout
        {...this.props}
        onHandleDescriptiveTrainingSubmit={this.permission.check(`permission:landings_${this.props.source}_article`, this.onHandleDescriptiveTrainingSubmit)}
      />
    )
  }
}

export default connect(mapStatesToProps)(DescriptivetrainingformModule)
